import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { api } from "@/lib/api";
import { NewsletterForm } from "@/components/news/NewsletterForm";
import { useSettings } from "@/context/SettingsContext";
import { BrandLogo } from "./SiteHeader";
import { FooterHeading, FooterRecent, FooterRubriques } from "./FooterColumns";

const FooterBottom = ({ siteName }) => (
  <div className="border-t border-white/10">
    <div className="container-site flex flex-col sm:flex-row items-center justify-between gap-3 py-5 text-xs text-zinc-500">
      <div className="text-center sm:text-left">
        <div>© {new Date().getFullYear()} {siteName || "Chronique.cd"} — Tous droits réservés.</div>
        <div data-testid="footer-credit" className="mt-1">Site conçu et maintenu par <span className="text-zinc-300 font-semibold">Eliah Consulting</span></div>
      </div>
      <div className="flex items-center gap-5">
        <Link to="/a-propos" className="hover:text-white transition-colors">À propos</Link>
        <Link to="/a-propos/equipe" className="hover:text-white transition-colors">Équipe</Link>
        <Link to="/admin/login" data-testid="footer-admin-login-link" className="inline-flex items-center gap-1.5 border border-zinc-600 px-3 py-1.5 text-zinc-300 hover:bg-red-600 hover:border-red-600 hover:text-white transition-colors font-semibold uppercase tracking-wider">
          <Lock size={12} /> Administration
        </Link>
      </div>
    </div>
  </div>
);

export const SiteFooter = () => {
  const { settings: s } = useSettings();
  const [recent, setRecent] = useState([]);
  useEffect(() => {
    api.get("/articles", { params: { limit: 4 } }).then((r) => setRecent(r.data.items)).catch((error) => console.error("Footer error:", error));
  }, []);

  return (
    <footer className="bg-[#111827] text-zinc-300 mt-12">
      <div className="container-site grid gap-10 md:grid-cols-2 lg:grid-cols-4 py-14">
        <div>
          <div className="text-white"><BrandLogo className="!text-3xl !h-12" /></div>
          <p className="text-sm mt-4 leading-6 text-zinc-400">{s.footer_about}</p>
          <p className="text-xs mt-4 text-zinc-500">{s.address}<br />{s.contact_email}</p>
        </div>
        <FooterRubriques />
        <FooterRecent recent={recent} />
        <div>
          <FooterHeading>Newsletter</FooterHeading>
          <p className="text-sm text-zinc-400 mb-4">Recevez chaque matin l'essentiel de l'actualité congolaise.</p>
          <NewsletterForm dark />
        </div>
      </div>
      <FooterBottom siteName={s.site_name} />
    </footer>
  );
};
